// Generated by scripts/sync-client-env.mjs — do not edit.
import type { StagingClientSecrets } from './environment.client.types';

export const stagingClientSecrets: StagingClientSecrets = {
  "stripePublicKey": "pk_test_51TXRzvRUeoABVSZZO6tVbyAxYy66cUiXgFlhbWwoVSJdAJX4myp9yMscFyEc8DO7JcFV9CO9zeN5MJxn3Pj5WB5300dhHxzqVg",
  "googleMapsApiKey": "AIzaSyBMfnn4sFlyvYPXw2wfz4oWioRrtHQVGZ8",
  "appCheckRecaptchaSiteKey": "6LfFJ_csAAAAACwjQtjq_m54vHUG-hkH1BbLv4Wx",
  "publicOrigin": "https://timeflexrent-mvp-v01.web.app"
};
